module.exports = __webpack_public_path__ + "static/pool2-e9fa706759a28a8a3752aaae492909db.jpg";